import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const ARTICLES = [
  {
    id: "delhi-stitch",
    kicker: "Field Report № 07",
    title: "A morning at the Delhi stitching floor.",
    excerpt: "We spent 6 hours behind the machines at Rangoli Streetworks. Here's what 47 stitches per inch actually looks like.",
    image: "https://images.unsplash.com/photo-1631125915902-d8abe9225ff2?w=1600",
    date: "12 Feb 2026",
    reading: "8 min",
    author: "The Perfectionist",
  },
  {
    id: "sizing-lies",
    kicker: "The Softie Files",
    title: "Why UK sizing is lying to your feet.",
    excerpt: "We measured 200 pairs. UK 9 ranged from 26.4 cm to 28.1 cm. BIS is the only chart worth trusting.",
    image: "https://images.unsplash.com/photo-1600185365483-26d7a4cc7519?w=1600",
    date: "04 Feb 2026",
    reading: "5 min",
    author: "The Softie",
  },
  {
    id: "counterfeit-hunt",
    kicker: "The Skeptic Diaries",
    title: "How we caught 14 fakes in a single week.",
    excerpt: "The tell was almost invisible: a heat-transfer logo that peeled at 42°C. We photographed every single one.",
    image: "https://images.unsplash.com/photo-1571513800374-df1bbe650e56?w=1600",
    date: "28 Jan 2026",
    reading: "11 min",
    author: "The Skeptic",
  },
  {
    id: "vendor-cut",
    kicker: "House Rules",
    title: "The vendor we had to drop last month.",
    excerpt: "A 6% failure rate. Three consecutive batches with the same defect. Loyalty isn't a shortcut past inspection.",
    image: "https://images.unsplash.com/photo-1666445844615-0a3930270f13?w=1600",
    date: "18 Jan 2026",
    reading: "4 min",
    author: "The House",
  },
];

export default function Journal() {
  const [lead, ...rest] = ARTICLES;
  return (
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16">
      <div className="flex items-end justify-between border-b-2 border-foreground pb-6 mb-12">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Issue 08 · Feb 2026</p>
          <h1 className="font-serif text-6xl md:text-8xl mt-2 tracking-tighter leading-none">The Journal.</h1>
        </div>
        <p className="hidden md:block font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
          Dispatches from the inspection floor
        </p>
      </div>

      <article className="grid md:grid-cols-12 gap-8 mb-24 group">
        <Link to="#" className="md:col-span-7 aspect-[16/10] overflow-hidden">
          <img src={lead.image} alt={lead.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        </Link>
        <div className="md:col-span-5">
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-[hsl(var(--accent))]">{lead.kicker}</p>
          <h2 className="font-serif text-5xl md:text-6xl mt-4 tracking-tighter leading-[0.95]">{lead.title}</h2>
          <p className="mt-6 text-muted-foreground text-lg leading-relaxed">{lead.excerpt}</p>
          <div className="mt-8 flex items-center gap-4 font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
            <span>{lead.date}</span><span>·</span><span>{lead.reading}</span><span>·</span><span>{lead.author}</span>
          </div>
          <Link to="#" className="mt-8 inline-flex items-center gap-2 border-b border-foreground pb-1 font-mono text-xs uppercase tracking-widest hover:text-[hsl(var(--accent))] hover:border-[hsl(var(--accent))]">
            Read the report <ArrowUpRight size={14} />
          </Link>
        </div>
      </article>

      <div className="grid md:grid-cols-3 gap-x-12 gap-y-16 border-t border-foreground pt-16">
        {rest.map((a) => (
          <article key={a.id} className="group">
            <Link to="#" className="block aspect-[4/3] overflow-hidden bg-secondary mb-4">
              <img src={a.image} alt={a.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </Link>
            <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-[hsl(var(--accent))]">{a.kicker}</p>
            <h3 className="font-serif text-2xl mt-2 leading-tight">{a.title}</h3>
            <p className="mt-3 text-sm text-muted-foreground">{a.excerpt}</p>
            <div className="mt-4 font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
              {a.date} · {a.author}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
